import { withDirectionalStatics } from '@ui/icons/utils/withDirectionalStatics'

export const FullScreenIcon = withDirectionalStatics((props) => {
  const { size = 20, color = 'currentColor' } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='fullscreen-icon'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.5 6A2.5 2.5 0 006 8.5V11h1V8.5C7 7.67 7.67 7 8.5 7H11V6H8.5ZM6 17v2.5A2.5 2.5 0 008.5 22H11v-1H8.5A1.5 1.5 0 017 19.5V17H6ZM19.5 7H17V6h2.5A2.5 2.5 0 0122 8.5V11h-1V8.5c0-.83-.67-1.5-1.5-1.5ZM22 19.5V17h-1v2.5c0 .83-.67 1.5-1.5 1.5H17v1h2.5A2.5 2.5 0 0022 19.5Z'
        fill={color}
      />
    </svg>
  )
})
